import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Applicant,
  ApplicationProps,
  coparcenersType,
  Document,
  individuals_Poa_nonIndividuals_Documents,
  PromotersAndPartnersType,
} from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { KeyValue } from '../ApplicationDetails/contributor';
import { Gridstyles, Item, ItemDetails } from '../ApplicationDetails';
import { SubHeading } from '../investors/components';
import {
  checkIfApplicationIsNonIndividual,
  currencyConversion,
  isHufType,
} from '../../utils/utilityFunctions';
import { investorTypeMasters } from '../../utils/constant';
import { MobileViewDataRow } from '../DataTable';
import {
  getPartnersDocuments,
  viewPartnersDownloadCell,
} from '../NonIndividualInvestor/ContributorDetails';
import { documentDetails } from '../investors/documentDetails';
import { useDispatch } from 'react-redux';
import { getDocuments } from '../../redux-store/actions/application';

export default function ContributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const { applicants = [], coparceners = [], promoters = [] } = application || {};
  const partnersHeaders = [
    {
      header: 'Name',
      label: 'name',
      valueGetter: (row: PromotersAndPartnersType) => row.name || 'N/A',
    },
    {
      header: 'Pan',
      label: 'pan',
      valueGetter: (row: PromotersAndPartnersType) => row.pan || 'N/A',
    },
    {
      header: 'Date of Birth',
      valueGetter: (row: PromotersAndPartnersType) =>
        (row.dateOfBirth ? formatShortDate(new Date(row.dateOfBirth)) : 'N/A') || 'N/A',
    },
    {
      header: 'Phone Number',
      label: 'pan',
      valueGetter: (row: PromotersAndPartnersType) => `${row?.countryCode} ${row.mobile}` || 'N/A',
    },
    {
      header: 'Email ID',
      label: 'eamil',
      valueGetter: (row: PromotersAndPartnersType) => row?.email || 'N/A',
    },
    {
      header: 'Designation',
      valueGetter: (row: PromotersAndPartnersType) =>
        row.relation === 'Others' ? row.designation : row.designation || 'N/A',
    },
    {
      header: 'Address Line 1',
      label: 'address1',
      valueGetter: (row: PromotersAndPartnersType) => row?.address1 || 'N/A',
    },
    {
      header: 'Address Line 2',
      label: 'address2',
      valueGetter: (row: PromotersAndPartnersType) => row?.address2 || 'N/A',
    },
    {
      header: 'Country',
      label: 'country',
      valueGetter: (row: PromotersAndPartnersType) => row?.country || 'N/A',
    },
    {
      header: 'State',
      label: 'state',
      valueGetter: (row: PromotersAndPartnersType) => row?.state || 'N/A',
    },
    {
      header: 'City',
      label: 'city',
      valueGetter: (row: PromotersAndPartnersType) => row?.city || 'N/A',
    },
    {
      header: 'Pincode',
      label: 'pincode',
      valueGetter: (row: PromotersAndPartnersType) => row?.pincode || 'N/A',
    },
  ];
  const headers = [
    {
      header: 'Name',
      label: 'name',
      valueGetter: (row: coparcenersType) => row.name || 'N/A',
    },
    {
      header: 'PAN',
      valueGetter: (row: coparcenersType) => row.pan.toUpperCase() || 'N/A',
    },
    {
      header: 'Email ID',
      valueGetter: (row: coparcenersType) => row.email || 'N/A',
    },
    {
      header: 'Relation',
      valueGetter: (row: coparcenersType) =>
        row.relation === 'Others' ? row.relationShipOthers : row.relation || 'N/A',
    },
    {
      header: 'Karta',
      valueGetter: (row: coparcenersType) => (row.karta ? String('Yes') : String('No') || 'N/A'),
    },
    {
      header: 'Mobile Number',
      valueGetter: (row: coparcenersType) =>
        row.mobile && row.countryCode ? row.countryCode + '-' + row.mobile : row.mobile || 'N/A',
    },
    {
      header: 'Date of Birth',
      valueGetter: (row: coparcenersType) =>
        (row.dob ? formatShortDate(new Date(row.dob)) : 'N/A') || 'N/A',
    },
    {
      header: 'Aadhar Last 4 Digit',
      valueGetter: (row: coparcenersType) => row.aadharNumber || 'N/A',
    },
    // {
    //   header: 'Designation',
    //   valueGetter: (row: coparcenersType) => row.designation || 'N/A',
    // },
    {
      header: 'Address Line 1',
      label: 'address1',
      valueGetter: (row: PromotersAndPartnersType) => row?.address1 || 'N/A',
    },
    {
      header: 'Address Line 2',
      label: 'address2',
      valueGetter: (row: PromotersAndPartnersType) => row?.address2 || 'N/A',
    },
    {
      header: 'Country',
      label: 'country',
      valueGetter: (row: PromotersAndPartnersType) => row?.country || 'N/A',
    },
    {
      header: 'State',
      label: 'state',
      valueGetter: (row: PromotersAndPartnersType) => row?.state || 'N/A',
    },
    {
      header: 'City',
      label: 'city',
      valueGetter: (row: PromotersAndPartnersType) => row?.city || 'N/A',
    },
    {
      header: 'Pincode',
      label: 'pincode',
      valueGetter: (row: PromotersAndPartnersType) => row?.pincode || 'N/A',
    },
  ];

  const [pramotorsDocData, setGroupSignatoriesDocData] = useState<documentDetails[]>([]);
  const [partnersAndPramotorsGroup, setPramotors] = useState<PromotersAndPartnersType[]>([]);

  const dispatch = useDispatch();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getDocuments())) as unknown as Document;
        const groupSignatoryData = (
          (response?.non_individual_partners as unknown as individuals_Poa_nonIndividuals_Documents[]) ||
          []
        ).map((_doc) => {
          return { ..._doc, documentId: '', isActive: true };
        });
        setGroupSignatoriesDocData(groupSignatoryData);
        const pramotorsObj = promoters.length
          ? promoters.map((group) => {
              return {
                ...group,
                promoterdocuments: group.promoterdocuments.map((signatory) => {
                  return {
                    ...signatory,
                    promoterdocuments: (promoters.length ? promoters : []).map((_partnersMap) => ({
                      ..._partnersMap,
                      promoterdocuments: getPartnersDocuments(response, _partnersMap),
                    })),
                  };
                }),
              };
            })
          : promoters;
        setPramotors((pramotorsObj || []) as PromotersAndPartnersType[]);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                Applicant(s) Details
              </Typography>
            </Grid>
            {applicants.map((applicant) => {
              return (
                <React.Fragment key={applicant.id}>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name Of Entity'} description={applicant.name} />
                      <KeyValue
                        title={'Date of Registration/Incorporation'}
                        description={formatShortDate(applicant.dateOfBirth)}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'Place of Registration/Incorporation'}
                        description={applicant.cityOfIncorporation}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'CKYC No./CKYC Acknowledge No./KIN No'}
                        description={applicant.ckycNo}
                      />
                      {applicant.investorType && (
                        <KeyValue
                          title={'Investor Type'}
                          description={investorTypeMasters[applicant.investorType]}
                        />
                      )}
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={21}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      {/* {applicant.yearWiseGrossIncome?.map((yearWiseData, index) => (
                        <React.Fragment key={index}>
                          <KeyValue
                            title={`Gross Annual Income ${
                              yearWiseData.fYear ? yearWiseData.fYear : '-'
                            }`}
                            description={yearWiseData.grossAnnualIncome}
                          />
                        </React.Fragment>
                      ))} */}
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      <KeyValue
                        title={'Net Worth'}
                        description={applicant.netWorth}
                        amount={currencyConversion(applicant.netWorth)}
                      />
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
            {isHufType(applicants || []) ? (
              checkIfApplicationIsNonIndividual(application as ApplicationProps) && (
                <>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'List of Coparceners'}
                  </SubHeading>
                  {coparceners?.length === 0 && (
                    <Grid
                      xs={12}
                      sm={12}
                      sx={{
                        fontSize: 18,
                        fontWeight: 600,
                        color: 'common.black',
                        textAlign: 'center',
                        my: 3,
                      }}>
                      No List of Coparceners
                    </Grid>
                  )}
                  {coparceners?.map((coparceners, index) => (
                    <React.Fragment key={coparceners.id}>
                      <Item
                        sx={{
                          marginBottom: '20px',
                          paddingLeft: { xs: '10px', sm: '30px' },
                        }}>{`Coparcener ${index + 1}`}</Item>
                      <MobileViewDataRow
                        index={index}
                        row={coparceners}
                        key={coparceners.id}
                        tableHeader={headers}
                      />
                    </React.Fragment>
                  ))}
                </>
              )
            ) : (
              <>
                <>
                  <Box
                    sx={{
                      bgcolor: 'white',
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                      borderRadius: '10px',
                    }}
                    mt={5}>
                    <Box sx={{ p: 2 }}>
                      <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                        <Typography
                          component="h2"
                          sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                          Promoters / Partners / Trustees
                        </Typography>
                        {partnersAndPramotorsGroup.length === 0 && (
                          <Grid
                            xs={12}
                            sm={12}
                            sx={{
                              fontSize: 18,
                              fontWeight: 600,
                              color: 'common.black',
                              textAlign: 'center',
                              my: 3,
                            }}>
                            No Promoters / Partners / Trustees
                          </Grid>
                        )}
                        {partnersAndPramotorsGroup.map((group, index) => {
                          return (
                            <React.Fragment key={group.id}>
                              <Grid container pt={3}>
                                <Grid xs={12} alignSelf="center">
                                  <MobileViewDataRow
                                    index={index}
                                    row={group}
                                    key={group.id}
                                    tableHeader={[
                                      ...partnersHeaders,
                                      ...viewPartnersDownloadCell(pramotorsDocData, true),
                                    ]}
                                  />
                                </Grid>
                              </Grid>
                            </React.Fragment>
                          );
                        })}
                      </Grid>
                    </Box>
                  </Box>
                </>
              </>
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
